import { render, staticRenderFns } from "./inventory_edit.vue?vue&type=template&id=edd80e06&scoped=true"
import script from "./inventory_edit.vue?vue&type=script&lang=js"
export * from "./inventory_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd80e06",
  null
  
)

export default component.exports